import { render, staticRenderFns } from "./stats-calendar.vue?vue&type=template&id=25e12218&"
import script from "./stats-calendar.vue?vue&type=script&lang=js&"
export * from "./stats-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports